import firebase from "../../firebase";

export default function({ email, officeId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "officeAdmin",
        funcName: "createUser",
        data: { email, officeId }
    });
}
